module.exports = __webpack_public_path__ + "teqbahn-assets/media/vidya.42d3e316.jpeg";